export const WIDGET_TYPES = Object.freeze({
  STAT: 'card',
  STACKED_BAR: 'stacked_bar',
  BAR: 'bar',
  BAR_PERCENTAGE: 'bar_percentage'
});
